import DOMPurify from 'dompurify';
import { marked } from 'marked';

const markdownToSafeHtml = (markdown) => {
  if (!markdown) {
    return '';
  }

  const html = marked.parse(markdown);
  const safe = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'b', 'i', 'em', 'strong', 'u', 'a', 'ul', 'ol', 'li', 'p', 'br',
      'blockquote', 'code', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    ],
    ALLOWED_ATTR: ['href', 'title', 'target', 'rel'],
  });

  return safe.replace(/<a (?![^>]*target=)/g, '<a target="_blank" rel="noopener noreferrer" ');
};

export default markdownToSafeHtml;
